export default {
  User: {
    ChangePassword: 'Đổi mật khẩu',
    AccountSetting: 'Thiết lập tài khoản',
    SecuritySetting: 'Thiết lập bảo mật',
    Language: 'Ngôn ngữ',
    Logout: 'Đăng xuất',
    ChangePasswordSuccess: 'Thay đổi mật khẩu thành công',
    ConfirmPassword: 'Xác nhận lại mật khẩu',
    EnterNewPassword: 'Mật khẩu mới',
    EnterOldPassword: 'Mật khẩu cũ',
    EnterCurrentPassword: 'Nhập mật khẩu hiện tại',
    EnterPassword: 'Nhập mật khẩu',
    UpperAndLowerLetter: 'Chữ hoa, thường',
    HasDigit: 'Có chữ số',
    EightCharacters: 'Ít nhất 8 ký tự',
    PasswordConfirmNotDuplicate: 'Mật khẩu xác nhận không khớp',
    NotAllowBlank: 'Không được bỏ trống',
    PasswordInvalid: 'Mật khẩu không chính xác',
    HasErrorTryAgain: 'Có lối xảy ra vui lòng thử lại',
    AccountDetail: 'Quản lý tài khoản',
    ProfileDetail: 'Quản lý hồ sơ',
    ClassroomList: 'Quản lý lớp học',
    ShowAccountDetail: 'Xem hồ sơ của bạn',
    Help: 'Trợ giúp',
    Hello: 'Xin chào, ',
    ProtectAccount: 'Bảo vệ tài khoản',
    ActivityLog: 'Nhật ký hoạt động',
    ThemeSetting: 'Thiết lập giao diện',
    EmisStudent: 'Lấy dữ liệu từ EMIS học sinh',
    HomeWorkEMIS: 'Ôn tập',
    AnswerEMIS: 'Kiểm tra',
    RoomEMIS: 'Phòng học trực tuyến',
    NoteHomeWork: 'Soạn và giao bài tập',
    NoteAnswer: 'Soạn đề và tổ chức đánh giá',
    NoteRoom: 'Tổ chức lớp học Online',
    ManangeStudentEMIS: 'Quản lý học sinh',
    NoteManageStudent: 'Nhận xét, đánh giá, ghi điểm',
    LinkSetup: 'Thiết lập liên kết',
    RegistrationForm: 'Đơn đăng ký học',
    RegistrationDay: 'Ngày đăng ký',
    RegistrationCourse: 'Học liệu đăng ký',
    TotalAmount: 'Tổng tiền',
    StatusForm: 'Trạng thái đơn',
    AmountVND: 'VND',
    Detail: 'Chi tiết',
    InforRegistrationForm: 'Thông tin đơn đăng ký',
    AwaitPayment: 'Vui lòng chuyển khoản theo thông tin dưới đây và đợi trong ít phút để có thể bắt đầu học tập.',
    RegisterComplete: 'Đơn đăng ký đã hoàn thành.<br> Bắt đầu ôn luyện khóa học đã đăng ký ngay bạn nhé!',
    RegisterExpire: 'Đơn đăng ký đã quá hạn thanh toán.',
    RegisterAgain: 'Bạn có thể đăng ký học lại các khóa học này ngay ',
    Here: ' tại đây.',
    TotalAmountToPay: 'Tổng tiền phải trả',
    AccountName: 'Tên tài khoản',
    CompanyName: 'Công ty Cổ phần MISA',
    AccountNumber: 'Số tài khoản',
    CompanyAccountNumber: '21137519',
    OpenAt: 'Mở tại',
    Bank: 'Hội sở Ngân hàng TMCP Á Châu',
    ContentTransfer: 'Nội dung chuyển',
    Expiration: 'Khóa học sẽ có thời hạn sử dụng là 12 tháng kể từ ngày thanh toán thành công.',
    ViewListRegistrationCourse: 'Xem danh sách học liệu đăng ký',
    Close: 'Đóng',
    RegisterSuccess: 'Học liệu đã kích hoạt thành công!',
    StartPractice: 'Bắt đầu ôn luyện các khóa học mới ngay bạn nhé!',
    Pending: 'Chờ thanh toán',
    Success: 'Hoàn thành',
    Canceled: 'Đã hủy',
    CopyTransferContentSuccess: 'Sao chép nội dung chuyển khoản thành công',
    CreateFormSuccess: 'Tạo đơn đăng ký học thành công',
    ExploreCourse: 'Khám phá học liệu',
    RegistrationTracking: 'Theo dõi đơn đăng ký',
    CourseName: '<div class="mb-3>{courseName}</div>',
    CopyTransferContent: 'Sao chép',
    // setup link in dashboard
    SetupLinkDriver: 'Liên kết Google Drive',
    EasySync: 'Dễ dàng <b>đồng bộ, sử dụng</b> tài liệu lưu trữ trên <b>Google Drive</b> khi <b>Giao bài tập</b>',
    SetupLinkDriverContent: 'Thiết lập liên kết tài khoản Google Drive',
    OptimalSolution: 'Giải pháp tối ưu <b>lưu trữ bài tập video</b> của học sinh khi gửi qua <b>Sisap Phụ huynh</b>',
    LoginNow: 'Đăng nhập ngay',
    // Exam Alert
    ExamAlertLogin: 'Đăng nhập vào làm bài',
    ExamAlertLeaveScreen: 'Thoát ra khỏi giao diện làm bài'
  }
}
